module.exports = __webpack_public_path__ + "960ffc5198d835ff78de3933e4910f1e.svg";